import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://shield-quotes.preview.emergentagent.com";

// Reusable SEO for public pages: title, description, canonical, OG, and optional JSON-LD.
export default function Seo({ title, description, path = "", keywords, jsonLd, faqs }) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | Keystone Shield Insurance` : "Keystone Shield Insurance | Fast, Free Insurance Quotes in PA, NJ, NY & FL";
  const schemas = [];
  if (jsonLd) schemas.push(jsonLd);
  if (faqs && faqs.length) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question", "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });
  }
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
